import { CompanySettingsCardTab } from '../../pages/company-settings/company-settings.types';
import { localStorageUtil } from '../../utils/local-storage.util';

export const companySettingsTabStore =
  localStorageUtil<CompanySettingsCardTab>('companySettingsTab');
